export var USER_RANK_USER = 'USER';
export var USER_RANK_FACILITATOR = 'FACILITATOR';
export var USER_RANK_ADMIN = 'ADMIN';
